import React from 'react';
import { Box } from '@mui/material';
import PageHeader from '../components/common/PageHeader';
import CalendarPage from './CalendarPage';

const AuditkalenderPage: React.FC = () => {
  return (
    <Box>
      <PageHeader title="Auditkalender" breadcrumbs={[{ label: 'Auditkalender' }]} />
      <CalendarPage hideHeader />
    </Box>
  );
};

export default AuditkalenderPage;
